/**
 * 楼层平面展示图
 */
import React from 'react';

import { List, Row } from 'antd';
//主楼1层
import JiMeiExhibitionF1 from './JiMeiExhibitionF1';
//主楼24楼，布局一样，共用1个页面
import JiMeiExhibition from './JiMeiExhibition';
//主楼5层，和其他楼层不一样，单独1个页面
import JiMeiExhibitionF5 from './JiMeiExhibitionF5';
//主楼3层，和其他楼层不一样，单独1个页面
import JiMeiExhibitionF3 from './JiMeiExhibitionF3';
//3号地，单独1个页面
import JiMeiExhibitionM3 from './JiMeiExhibitionM3';
//服务站1楼
import JiMeiExhibitionM4F1 from './JiMeiExhibitionM4F1'
//服务站2楼
import JiMeiExhibitionM4F2 from './JiMeiExhibitionM4F2'
import http from '../../../axios/http';

class BerthExhibition extends React.Component {

    state = {
        floorList: [],  //楼层信息
        selectFloor: ''
    };

    // componentDidMount() {
    //     //this.loadFloor();
    // }
    

    //加载楼层信息,floorId 要加载的楼层的Id
    loadFloor = (buildingId) => {
        http.get({
            url: "/berth/findFloor",
            data:{
                buildingId: buildingId
            },
            success: (floorData) => {
                this.dealFloorData(floorData);
                // let floorList = [];
                // let selectFloor = null;
                // if (floorData != null) {
                //     floorList = floorData;
                //     selectFloor = floorData[0]["id"];
                //     //加载铺位信息
                //     this.loadBerth(selectFloor);
                // }
                // this.setState({ floorList: floorList, selectFloor: selectFloor });
            }
        });
    }

    //加载楼层信息，已经有了楼层的列表信息，不用再发起请求
    dealFloorData = (floorData) =>{
        // console.info(floorData);
        let floorList = [];
        let selectFloor = null;
        if (floorData != null && floorData.length > 0) {
            floorList = floorData;
            selectFloor = floorData[0]["id"];
            //加载铺位信息
            this.loadBerth(selectFloor);
        }
        this.setState({ floorList: floorList, selectFloor: selectFloor });
    }

    //加载铺位信息
    loadBerth = (floorId) => {
        http.get({
            url: "/berth/findBerthRentInfo",
            data: { floorId: floorId },
            success: (res) => {
                //处理楼层信息
                //处理铺位的编码信息
                if(res != null && res.length > 0){
                    for(let i in res){
                        let item = res[i];
                        let berthCode = item.berthCode;
                        item.berthFullCode = berthCode;
                        berthCode = berthCode.split("-");
                        // 对于M1-F4-01-2这样的格式，提取01-2部分
                        if (berthCode.length >= 4) {
                            item.berthCode = berthCode[berthCode.length-2] + "-" + berthCode[berthCode.length-1];
                        } else {
                            // 保留原有的逻辑作为后备
                            item.berthCode = berthCode[berthCode.length-1];
                        }
                    }
                }
                this.refs["floor"].setBerthInfo(res);
            }
        })
    }

    clickFloor = (info, e) => {
        if (this.state.selectFloor === info.id) {
        } else {
            this.setState({ selectFloor: info.id });
            this.loadBerth(info.id); //加载楼层
        }
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <style>
                    {`
                        .catetory-list-item{
                            padding: 0 !important;
                        }
                        .catetory-list-item>span{
                            padding: 12px 0px 12px 10px !important;
                        }
                        .catetory-list-item:hover{
                            background: #CCE6FF;
                        }
                        .catetory-list-item.on{
                            background:#0070C0;
                            color:#ffffff;
                        }
                    `}
                </style>
                <div style={{ overflow: 'auto', height: '100%', float: 'left', width: '100px', paddingRight: '5px', borderRight: '1px solid #e8e8e8' }}>
                    <List
                        itemLayout="horizontal"
                        dataSource={this.state.floorList}
                        renderItem={item => (
                            <List.Item className={['catetory-list-item', this.state.selectFloor === item.id ? 'on' : '']} >
                                <span style={{ width: '100%', cursor: 'pointer', display: 'block' }}
                                    onClick={this.clickFloor.bind(this, item)}
                                >{item.floorName}</span>
                            </List.Item>
                        )}
                    />
                    <div style={{position: "fixed", bottom:"50px"}}>
                        <Row><div style={{ width: 10, height: 10, background: "#60acfc", float: "left", margin: "6px 3px 0 0" }}></div><div style={{ float: "left" }}>未出租</div></Row>
                        <Row><div style={{ width: 10, height: 10, background: "#5bc49f", float: "left", margin: "6px 3px 0 0" }}></div><div style={{ float: "left" }}>已出租</div></Row>
                        <Row><div style={{ width: 10, height: 10, background: "#feb64d", float: "left", margin: "6px 3px 0 0" }}></div><div style={{ float: "left" }}>即将到期</div></Row>
                        <Row><div style={{ width: 10, height: 10, background: "#DDDDDD", float: "left", margin: "6px 3px 0 0" }}></div><div style={{ float: "left"}}>办公区</div></Row>
                    </div>
                </div>
                <div style={{ overflow: 'hidden', height: '100%', float: 'right', width: "calc(100% - 100px)", position: 'relative' }}>
                    {this.state.selectFloor===1?<JiMeiExhibitionF1 ref="floor"/>
                    :this.state.selectFloor===5?<JiMeiExhibitionF5 ref="floor"/>
                    :this.state.selectFloor===3?<JiMeiExhibitionF3 ref="floor"/>
                    :this.state.selectFloor===7?<JiMeiExhibitionM3 ref="floor"/>
                    :this.state.selectFloor===8?<JiMeiExhibitionM4F1 ref="floor"/>
                    :this.state.selectFloor===9?<JiMeiExhibitionM4F2 ref="floor"/>
                    :<JiMeiExhibition ref="floor" selectFloor={this.state.selectFloor} />}
                </div>
            </div>
        )
    }

}

export default BerthExhibition;